<template>
  <div id="app">
    <v-app>
      <router-view />
      <FooterItem />
    </v-app>
  </div>
</template>

<script>
import FooterItem from './components/FooterItem'

export default {
  name: 'App',

  components: {
    FooterItem
  },

  data: () => ({
    //
  }),
};
</script>

<style>
.v-application{
  font-family: 'Noto Sans JP', sans-serif!important;
}
</style>